import { Children, cloneElement } from 'react';
import { isFunction } from './index.js';
function seizeAndForwardChildrenEvents(children, events, props) {
    return Children.map(children, (child) => {
        const newProps = {
            ...props,
        };
        events.forEach(([eventName, fn]) => {
            const originalEvent = child.props[eventName];
            newProps[eventName] = function eventWrapper(...args) {
                if (isFunction(fn)) {
                    fn(...args);
                }
                if (isFunction(originalEvent)) {
                    originalEvent(...args);
                }
            };
        });
        return cloneElement(child, newProps);
    });
}
export default seizeAndForwardChildrenEvents;
//# sourceMappingURL=seize-and-forward-children-event.js.map